import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { HelpersService } from './helpers.service';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SyncProgressService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
  ) {
    this.env = this.appConfig.getPOSEnvironment();
  } 

  getSyncProgress() {
    console.log('Fetching sync progress...', this.env );
    const headers = this.helpersService.getPOSApiHeaders(this.appConfig.getPOSEnvironment().key);
    return this.http
      .get(this.env.url + '/sync/progress?code=' + this.env.key, headers)
      .pipe(
        map((res: any) => res),
        catchError((res: any) => throwError(res)),
      );
  }
}
